import { render, staticRenderFns } from "./holy-grail.template.html?vue&type=template&id=93aef9cc&scoped=true&"
var script = {}
import style0 from "./column.template.vue?vue&type=style&index=0&id=93aef9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aef9cc",
  null
  
)

export default component.exports